__turbopack_context__.v({
  "className": "tiro_devanagari_hindi_ae2be5cb-module__bwfZfa__className",
});
